import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { m } from 'framer-motion';
import { Parallax } from 'react-scroll-parallax';
import { fadeIn } from '../../../Litho/Functions/GlobalAnimations';
import Buttons from '../../../Litho/Components/Button/Buttons';

const CTAParallax = () => {
	return (
		<m.div
			className='py-[130px] overflow-hidden relative lg:py-[95px] md:py-[75px] sm:py-[50px]'
			{...fadeIn}
		>
			<Parallax
				className='lg-no-parallax bg-center bg-cover absolute top-[-80px] left-0 w-full h-[75vh] mxl:h-[740px] sm:-top-[70px] mxl:top-0'
				translateY={[-40, 40]}
				style={{
					backgroundImage: `url(https://via.placeholder.com/1920x1100?text=Ocean+CTA)`,
				}}
			></Parallax>
			<div className='absolute top-0 left-0 w-full h-full opacity-80 bg-gradient-to-tr from-[#0039e3] to-[#8600d4]'></div>
			<Container>
				<Row className='items-center justify-center'>
					<Col
						xl={7}
						md={8}
						xs={12}
						className='relative sm:text-center sm:mb-[30px]'
					>
						<h4 className='font-serif font-semibold text-white mb-0'>
							Move cargo smartly with ocean logistics
						</h4>
					</Col>
					<Col xl={5} md={4} className='relative text-right sm:text-center'>
						<Buttons
							href='/contact-us'
							className='font-medium font-serif uppercase rounded-none'
							themeColor={['#b884fd', '#fd9395']}
							size='lg'
							color='#fff'
							title='Get sea freight quote'
						/>
					</Col>
				</Row>
			</Container>
		</m.div>
	);
};

export default CTAParallax;
